import { faComment } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString } from "et3-type-guards";
import {
  SEARCH_BY_INPUT_USER_ID,
  USER_SEARCH_BY_ENTRIES
} from "../../../../../../constants/picker-entries-constants";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import ET3Radio from "../../../../../../core/et3-input/et3-radio";
import Et3TextInput from "../../../../../../core/et3-input/et3-text-input";
import GetUserButton from "../../GetUserButton";
import {
  SEARCH_FORM_BUTTON_TOP_OFFSET,
  SEARCH_FORM_FIELD_GAP,
  SEARCH_FORM_INPUT_WIDTH,
  SEARCH_FORM_ROW_GAP
} from "../../search-form-constants";

const OptionForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX, colors, unitY } = theme;
  const userAdvancedStore = getUserAdvancedStore();
  const ifInputTypeUserID =
    getUserAdvancedStore().searchByInput.get() === SEARCH_BY_INPUT_USER_ID;
  const inputLabel = isDefinedString(
    getUserAdvancedStore().advancedSearchInput.get()
  )
    ? getUserAdvancedStore().advancedSearchInput.get()
    : getUserAdvancedStore().getInputPlaceholder.get();

  // Checking if searchInput is now PhoneNumber to Be Able to do the Validation
  const selectedOption = USER_SEARCH_BY_ENTRIES.find(
    (option) => option.value === userAdvancedStore.searchByInput.get()
  );
  const isPhoneNumberOption =
    selectedOption && selectedOption.value === "phoneNumber";
  const isProfileID = selectedOption && selectedOption.value === "profileId";

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        gap: SEARCH_FORM_ROW_GAP * unitY
      }}
      onClick={() => {}}
    >
      <ET3Radio
        options={USER_SEARCH_BY_ENTRIES}
        value={userAdvancedStore.searchByInput.get()}
        onChoose={(value) => {
          userAdvancedStore.advancedSearchInput.set("");
          userAdvancedStore.setSearchByInput(`${value}`);
        }}
        style={{
          width: "100%",
          minHeight: 0,
          display: "grid",
          gridTemplateColumns: `repeat(${USER_SEARCH_BY_ENTRIES.length}, minmax(0, 1fr))`
        }}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{
          width: "100%",
          minWidth: 0,
          flexWrap: "wrap",
          gap: `${SEARCH_FORM_ROW_GAP * unitY}px ${
            SEARCH_FORM_FIELD_GAP * unitX
          }px`
        }}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={!ifInputTypeUserID ? "text" : "number"}
          icon={faComment}
          label={getUserAdvancedStore().getInputPlaceholder.get()}
          placeHolder={inputLabel}
          value={getUserAdvancedStore().advancedSearchInput.get()}
          onChoose={(value) => {
            getUserAdvancedStore().handleOnChooseInputAdvanced(
              value,
              isPhoneNumberOption,
              ifInputTypeUserID,
              isProfileID
            );
          }}
          onBlur={() => {}}
          onEnter={() => getUserAdvancedStore().getUserData(true)}
          style={{
            width: SEARCH_FORM_INPUT_WIDTH * unitX
          }}
        />
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={0}
          height={0}
          fDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          color={colors.all.transparent}
          style={{
            width: "auto",
            flexShrink: 0,
            marginTop: SEARCH_FORM_BUTTON_TOP_OFFSET * unitY
          }}
          onClick={() => {}}
        >
          <GetUserButton />
        </ET3Div>
      </ET3Div>
    </ET3Div>
  );
});

export default OptionForm;
